import { FaPlayCircle, FaArrowUp } from "react-icons/fa";
import { Link } from "react-router-dom";
import cardImage from "../assets/FeaturePics/card.png";
import SmallCard from "../components/SmallCard";
import bg1 from "../assets/BackgroundImages/BG image 1.png";
import bg2 from "../assets/BackgroundImages/BG image 2.png";
import promoImage from "../assets/FeaturePics/FeaturePic1.webp";  // Make sure you have this image

const Features = () => {
  return (
    <>
      {/* Background Images */}
      <div className=" -z-10 absolute h-full opacity-50 right-0 ">
        <img
          src={bg1}
          alt="bg"
          className="h-full w-auto object-contain"
        />  
      </div>

      <div className="hidden md:block -z-10 absolute h-full opacity-50 left-0">
        <img
          src={bg2}
          alt="bg"
          className="h-full w-auto object-contain"
        />  
      </div>

      <div className="relative text-white py-20 px-10 md:px-20">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 max-w-6xl mx-auto">
          <div className="text-center md:text-left md:max-w-lg">
            <h1 className="text-5xl font-bold mb-4">
              Powerful Features to Simplify Your Hiring
            </h1>
          </div>

          <div className="text-center md:text-left md:max-w-lg">
            <p className="text-gray-300 mb-6">
              From AI-powered candidate sourcing to seamless team collaboration, our all-in-one recruitment
              platform streamlines every step of the hiring process.
              <br />
              Automate workflows, make data-driven decisions.
            </p>

            {/* Buttons */}
            <div className="flex gap-4 justify-center md:justify-start">
              <Link to="/contact">
                <button className="bg-[#19BFB7] flex items-center gap-2 border-2 border-[#19BFB7] rounded-full py-2 px-6 text-white hover:bg-white hover:text-[#0f1d35] transition duration-300 transform hover:scale-105">
                  <FaPlayCircle /> Request a Demo
                </button>
              </Link>

              <Link to="/fund">
                <button className="bg-[#19BFB7] flex items-center gap-2 border-2 border-[#19BFB7] rounded-full py-2 px-6 text-white hover:bg-white hover:text-[#0f1d35] transition duration-300 transform hover:scale-105">
                  Our Impact Fund
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* How We Help Section */}
      <div
        className="py-20"
        style={{
          backgroundImage: `url(${cardImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
        }}
      >
        <h1 className="text-center text-white text-5xl font-bold mb-10">
          How we <span className="text-[#19BFB7]">Help</span>
        </h1>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 max-w-6xl mx-auto">
          {/* Card 1 */}
          <div className="bg-[#11243b] rounded-lg p-8 text-center shadow-lg max-w-sm w-full transition-transform transform hover:scale-105">
            <h2 className="text-xl font-semibold mb-2">
              Streamlined Hiring Workflow
            </h2>
            <p className="text-gray-300">
              AIAURA automates repetitive tasks like resume screening, interview scheduling, and candidate follow-ups, freeing up recruiters to focus on more strategic activities.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#11243b] rounded-lg p-8 text-center shadow-lg max-w-sm w-full transition-transform transform hover:scale-105">
            <h2 className="text-xl font-semibold mb-2">
              AI-Powered Talent Matching
            </h2>
            <p className="text-gray-300">
              Uses advanced AI algorithms to match candidates with roles based on skills, experience, and company culture while improving candidate-job fit.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-[#11243b] rounded-lg p-8 text-center shadow-lg max-w-sm w-full transition-transform transform hover:scale-105">
            <h2 className="text-xl font-semibold mb-2">
              Improving Candidate Experience
            </h2>
            <p className="text-gray-300">
              Provides personalized job recommendations with AI-driven career insights, ensuring clear communication with automated updates and real-time feedback.
            </p>
          </div>
        </div>
      </div>

      {/* Our Features Section */}
          {/* Background Images */}
          <div className=" -z-10 absolute h-full opacity-50 right-0 ">
        <img
          src={bg1}
          alt="bg"
          className="h-full w-auto object-contain"
        />  
      </div>

      <div className=" -z-10 absolute h-full opacity-50 left-0 translate-y-[550px] md:translate-y-[250px]">
        <img
          src={bg2}
          alt="bg"
          className="h-full w-auto object-contain"
        />  
      </div>
      <div className="py-20 ">
        <h1 className="text-center text-white text-5xl font-bold mb-10">
          Our <span className="text-[#19BFB7]">Features</span>
        </h1>
        <div className="mb-10 bg-[#11243b] p-4 rounded-lg border-l-4 border-cyan-400">
          <p className="text-gray-300 italic text-center">
            "Where AI Precision Meets Human Potential"
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto px-4">
          {[
            {
              title: "Enhanced Collaboration",
              description:
                "The platform allows seamless collaboration between HR teams, hiring managers, and consultants with integrated communication and feedback systems.",
            },
            {
              title: "Data-Driven Decision Making",
              description:
                "Delivers real-time hiring analytics and predictive insights to optimize recruitment strategies.",
            },
            {
              title: "Unbiased AI Screening",
              description:
                "Uses unbiased AI screening to eliminate human bias and promote fair hiring decisions.",
            },
            {
              title: "Scalable and Flexible",
              description:
                "Whether hiring for one role or scaling rapidly, AIAURA adapts to changing recruitment needs.",
            },
            {
              title: "Improved Candidate Experience",
              description:
                "A seamless, personalized candidate journey enhances the employer brand.",
            },
            {
              title: "Strategic Workforce Planning",
              description:
                "Assists in strategic workforce planning by providing insights into talent trends.",
            },
          ].map((feature, index) => (
            <div
              key={index}
              className="bg-[#11243b] rounded-lg p-6 flex flex-col justify-between text-center md:text-left shadow-lg transition-transform transform hover:scale-105"
            >
              <h2 className="text-xl font-semibold mb-2">{feature.title}</h2>
              <p className="text-gray-300 mb-4">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>

    {/* Background Images */}
    <div className=" -z-10 absolute h-full opacity-50 right-0 translate-y-[400px]">
        <img
          src={bg1}
          alt="bg"
          className="h-full w-auto object-contain"
        />  
      </div>

      <div className=" -z-10 absolute h-full opacity-50 left-0 translate-y-[800px] md:translate-y-[600px]">
        <img
          src={bg2}
          alt="bg"
          className="h-full w-auto object-contain"
        />  
      </div>
      {/* Promotional Image Section */}
      <div className="my-12 max-w-6xl mx-auto">
        <img
          src={promoImage}
          loading="lazy"
          alt="Promotional"
          className="w-full h-auto object-cover rounded-xl shadow-lg"
        />
      </div>

     

      {/* Unlocking AIAURA Section */}
      <div className="py-20 px-10">
        <h2 className="text-center text-white text-4xl font-bold mb-10">
          Unlocking Recruiting Excellence with <span className="text-[#19BFB7]">AIAURA</span>
        </h2>
        <p className="text-center text-gray-300 mb-16 max-w-2xl mx-auto">
          AIAURA cuts down manual tasks, reduces time-to-hire, and boosts candidate engagement through personalized, automated outreach.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {[
            { title: "Shared Talent Pool", description: "Allow recruitment teams to collaboratively build and manage a centralized talent pool, reducing duplicate efforts." },
            { title: "Automated Follow-Ups", description: "Schedule follow-up emails or messages to maintain candidate engagement throughout the hiring process." },
            { title: "Hiring Trend Analysis", description: "Offer predictive analytics to identify trends, such as peak hiring times or in-demand skills." },
            { title: "Automated Job Posting", description: "Multi-channel job postings to platforms like LinkedIn, Indeed, and niche job boards." },
            { title: "Digital Onboarding", description: "Manage contracts, offer letters, and onboarding checklists directly within AIAURA." },
            { title: "Scalable Infrastructure", description: "Cloud-based architecture to support growing recruitment needs without compromising performance." }
          ].map((feature, index) => (
            <div key={index} className="bg-[#11243b] rounded-lg p-6 text-center shadow-lg transition-transform transform hover:scale-105">
              <h3 className="text-xl font-semibold text-[#19BFB7] mb-2">{feature.title}</h3>
              <p className="text-gray-300">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
      <SmallCard />
    </>
  );
};

export default Features;
